import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel, Row, Col, Grid, Avatar, Input, ControlLabel, Button } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import AppContext from '../../context/AppContext'
import TableLoadingTemplate from '../../widgets/loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function SearchSubProject({ config, onSettingChange = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const { Column, HeaderCell, Cell } = Table
  const contextValue = React.useContext(AppContext)

  const mockSchema = {
    header: 'โครงการย่อย',
    subHeader: 'รายการโครงการย่อย',
    codeText: 'รหัสโครงการย่อย',
    nameSubText: 'ชื่อโครงการย่อย',
    nameMainText: 'ชื่อโครงการหลัก',
    startDateText: 'วันที่เริ่ม',
    endDateText: 'วันที่สิ้นสุด',
    projectTypeText: 'ประเภทโครงการ',
    editDateText: 'แก้ไขล่าสุด',
    typeText: 'สถานะ',
    form: {
      buttonText: 'ค้นหา',
      inputMain: {
        name: 'projectMain',
        label: 'ชื่อโครงการหลัก',
        value: '',
      },
      inputSub: {
        name: 'projectSub',
        label: 'ชื่อโครงการย่อย',
        value: '',
      },
    },
    values: [
      {
        code: '63-0001',
        type: { icon: 'building2', projectType: 'แผนงาน ' },
        projectName: 'สานต่อโครงการอารักข์ สร้างภูมิคุ้มกันตั้งแต่เยาว์วัย',
        colorstatus: { code: 1, labal: 'อนุมัติ ' },
        status: 'อนุมัติ',
        date: 'เวอร์ชั่น 1.01 19 พ.ย. 2563 07:57 น.',
        dateStart: '18 พ.ย. 2563 07:57 น.',
        dateEnd: '22 พ.ย. 2563 07:57 น.',
      },
      {
        code: '63-0002',
        type: { icon: 'copy-o', projectType: 'ชุดโครงการ ' },
        projectName: 'เดินหน้าโครงการชุมชนจักรยานเพื่อสุขภาวะ ปี 3',
        colorstatus: { code: 2, labal: 'สิ้นสุดโครงการ ' },
        status: 'สิ้นสุดโครงการ',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
        dateStart: '18 พ.ย. 2563 07:57 น.',
        dateEnd: '22 พ.ย. 2563 07:57 น.',
      },
      {
        code: '63-0003',
        type: { icon: 'file-o', projectType: 'โครงการ ' },
        projectName: 'โครงการธนาคารเวลา',
        colorstatus: { code: 3, labal: 'ยืนข้อเสนอ ' },
        status: 'ยืนข้อเสนอ ',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
        dateStart: '18 พ.ย. 2563 07:57 น.',
        dateEnd: '22 พ.ย. 2563 07:57 น.',
      },
      {
        code: '63-0004',
        type: { icon: 'file-o', projectType: 'โครงการ ' },
        projectName:
          'รร.พระยามนธาตุราชศรีพิจิตร์ จัดโครงการสื่อสร้างสรรค์อย่าปล่อยให้เด็กอ้วนรร.พระยามนธาตุราชศรีพิจิตร์ จัดโครงการสื่อสร้างสรรค์อย่าปล่อยให้เด็กอ้วนรร.พระยามนธาตุราชศรีพิจิตร์ จัดโครงการสื่อสร้างสรรค์อย่าปล่อยให้เด็กอ้วน',
        colorstatus: { code: 4, labal: 'กลั่นกรอง ' },
        status: 'กลั่นกรอง',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
        dateStart: '18 พ.ย. 2563 07:57 น.',
        dateEnd: '22 พ.ย. 2563 07:57 น.',
      },
      {
        code: '63-0005',
        type: { icon: 'building2', projectType: 'แผนงาน ' },
        projectName: 'ประชุมโครงการพัฒนารูปแบบความร่วมมือเพื่อขับเคลื่อนสุขภาวะ',
        colorstatus: { code: 5, labal: 'ทำสัญญา ' },
        status: 'ทำสัญญา',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
        dateStart: '18 พ.ย. 2563 07:57 น.',
        dateEnd: '22 พ.ย. 2563 07:57 น.',
      },
      {
        code: '63-0006',
        type: { icon: 'building2', projectType: 'แผนงาน ' },
        projectName: "ประกวดนวัตกรรม 'กาย จิต ปัญญา สังคม'",
        colorstatus: { code: 5, labal: 'ทำสัญญา ' },
        status: 'ทำสัญญา',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
        dateStart: '18 พ.ย. 2563 07:57 น.',
        dateEnd: '22 พ.ย. 2563 07:57 น.',
      },
    ],
  }

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()
    try {
      console.log()
      setSchema(mockSchema)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <Grid fluid>
        <Row>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              width: 40,
              height: 40,
              background: contextValue.theme[0] == 'dark' ? '#515151' : '#f5f5f5',
              borderRadius: 20,
              marginTop: 2,
              overflow: 'hidden',
              display: 'inline-block',
            }}
          >
            <Icon
              icon={rowData[dataKey].icon}
              size={'lg'}
              style={{ marginLeft: 6, marginTop: 10 }}
            />
            {/* <img src={rowData[dataKey]} width="44" /> */}
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} style={{ marginTop: 10 }}>
            {rowData[dataKey].projectType}
          </Col>
        </Row>
      </Grid>
    </Cell>
  )

  const TagCell = ({ rowData, dataKey, ...props }) => {
    let color
    switch (rowData[dataKey].code) {
      case 1:
        color = '#24c2a1'
        break
      case 2:
        color = '#24c2a1'
        break
      case 3:
        color = '#f88781'
        break
      case 4:
        color = '#f8bb6a'
        break
      case 5:
        color = '#70b4e5'
        break
      case 6:
        color = '#8cc2ff'
        break
    }
    // console.log(color)
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <Row>
          <Col lg={12} style={{ marginTop: 10 }}>
            <Avatar style={{ backgroundColor: color, width: 100, fontSize: 15, height: 30 }}>
              {rowData[dataKey].labal}
            </Avatar>
          </Col>
        </Row>
        {/* {console.log(rowData[dataKey].labal)}
        {console.log(rowData[dataKey].code)} */}
      </Cell>
    )
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <Panel header={schema.header} bordered collapsible shaded defaultExpanded>
            {/* <Grid> */}
            <Row>
              <Col lg={8} md={8} sm={8} xs={8}>
                <ControlLabel>{schema.form.inputMain.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.form.inputMain.name}
                  defaultValue={schema.form.inputMain.value}
                ></Input>
              </Col>
              <Col lg={8} md={8} sm={8} xs={8}>
                <ControlLabel>{schema.form.inputSub.label}</ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  name={schema.form.inputSub.name}
                  defaultValue={schema.form.inputSub.value}
                ></Input>
              </Col>
              <Col lg={8} md={8} sm={8} xs={8}>
                <div>
                  <br />
                  <Button size="sm" appearance="ghost" style={{ width: '50%', height: '35px' }}>
                    {schema.form.buttonText}
                  </Button>
                </div>
              </Col>
            </Row>
            {/* </Grid> */}
            <br />
            <Panel header={schema.subHeader} defaultExpanded>
              <Table
                wordWrap
                height={300}
                loading={isLoading}
                data={schema?.values}
                onRowClick={(data) => {
                  console.log(data)
                }}
              >
                <Column align="center" width={130} fixed>
                  <HeaderCell>
                    <span>{schema.codeText}</span>
                  </HeaderCell>
                  <Cell dataKey="code" />
                </Column>
                <Column width={300}>
                  <HeaderCell>
                    <span>{schema.nameSubText}</span>
                  </HeaderCell>
                  <Cell dataKey="projectName" />
                </Column>
                <Column width={300}>
                  <HeaderCell>
                    <span>{schema.nameMainText}</span>
                  </HeaderCell>
                  <Cell dataKey="projectName" />
                </Column>
                <Column width={100}>
                  <HeaderCell>
                    <span>{schema.startDateText}</span>
                  </HeaderCell>
                  <Cell dataKey="dateStart" />
                </Column>
                <Column width={100}>
                  <HeaderCell>
                    <span>{schema.endDateText}</span>
                  </HeaderCell>
                  <Cell dataKey="dateEnd" />
                </Column>
                <Column width={160}>
                  <HeaderCell>
                    <span>{schema.projectTypeText}</span>
                  </HeaderCell>
                  <ImageCell dataKey="type" />
                </Column>
                <Column width={110}>
                  <HeaderCell>
                    <span>{schema.typeText}</span>
                  </HeaderCell>
                  <TagCell dataKey="colorstatus" />
                </Column>

                <Column width={100}>
                  <HeaderCell>
                    <span>{schema.editDateText}</span>
                  </HeaderCell>
                  <Cell dataKey="date" />
                </Column>
              </Table>
            </Panel>
          </Panel>
        </>
      )}
    </>
  )
}
